import {
  ProgressLayoutSkeleton,
  SuspensePageBoundary,
} from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { GraphemeInfoLearningProgressScreenSuspense } from "#grapheme-info-learning-progress-screen-suspense";

export function GraphemeInfoLearningProgressScreen({ grapheme }: { grapheme: string }) {
  return (
    <SuspensePageBoundary fallback={<ProgressLayoutSkeleton />} location={import.meta.location}>
      <GraphemeInfoLearningProgressScreenSuspense character={grapheme} />
    </SuspensePageBoundary>
  );
}
